import { Monitor, Moon, Sun } from 'lucide-react'
import { IconButton } from '@/components/ui/button'
import { useTheme, type ThemePreference } from '@/lib/theme'

const NEXT: Record<ThemePreference, ThemePreference> = {
  system: 'light',
  light: 'dark',
  dark: 'system',
}
const LABEL: Record<ThemePreference, string> = {
  system: 'Theme: system (click for light)',
  light: 'Theme: light (click for dark)',
  dark: 'Theme: dark (click for system)',
}

/** Cycles system → light → dark. */
export function ThemeToggle() {
  const { preference, setPreference } = useTheme()
  const Icon = preference === 'system' ? Monitor : preference === 'light' ? Sun : Moon
  return (
    <IconButton label={LABEL[preference]} onClick={() => setPreference(NEXT[preference])}>
      <Icon />
    </IconButton>
  )
}
